import React from "react";
import { Modal, ModalProps, Switch, Table } from "antd";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type FeaturePreviewModalProps = ModalProps;

export enum Feature {
  largeOrder = "largeOrder",
  shipmentCreate = "shipmentCreate",
}
interface FeaturePreviewState {
  feature: Record<Feature, boolean>;
  toggle: (feature: Feature) => void;
}

interface FeaturePreview {
  key: Feature;
  name: string;
  description: string;
}

// TODO move store to /hooks folder
export const useFeaturePreviewStore = create<FeaturePreviewState>()(
  persist(
    (set) => ({
      feature: {
        largeOrder: true,
        shipmentCreate: true,
      },
      toggle: (feature) =>
        set((state) => ({ ...state, feature: { ...state.feature, [feature]: !state.feature[feature] } })),
    }),
    {
      name: "feature_preview",
    }
  )
);

const dataSource: FeaturePreview[] = [];

export const FeaturePreviewModal: React.FC<FeaturePreviewModalProps> = (props) => {
  const { feature, toggle } = useFeaturePreviewStore();

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "State",
      dataIndex: "key",
      key: "key",
      render: (key: Feature) => {
        return (
          <Switch checkedChildren="On" unCheckedChildren="Off" checked={feature[key]} onClick={() => toggle(key)} />
        );
      },
    },
  ];
  return (
    <Modal {...props} title="Feature Preview" footer={null}>
      <Table dataSource={dataSource} columns={columns} pagination={false} />
    </Modal>
  );
};
